module.exports = "images/10ans.86701237.png";